const getDefaultState = () => {
  return {
    menuCollapsed: false,
    home: {
      gettingStartedExpanded: true
    },

    handWritings: {
      financialPlanOverview: true,
      businessGuideIdea: true,

      addIdeaSuggestion: true,
      addProductAndServiceSuggestion: true,
      addMarketingSuggestion: true,
      addSalesSuggestion: true,
      addPartnersSuggestion: true,
      addCustomersSuggestion: true,
      addCompetitorsSuggestion: true,
      addStartupCostsSuggestion: true,
      addPayrollExpensesSuggestion: true,
      addRevenueStreamSuggestion: true,
      addDirectCostsSuggestion: true,
      addMarketingCostsSuggestion: true,
      addOverheadExpensesSuggestion: true,
      addSWOTAnalysisSuggestion: true,
      aiHelpMeWrite: true
    },

    aiBuddyButtonAnimationShow: {
      defaultButton: true,
      roundedButton: true,
      roundedButtonAddModal: true,
      suggestionButtonAddModal: true
    },

    businessPlanAdditionalInfoExpand: {
      Idea: true,
      Product: true,
      Promotion: true,
      Distribution: true,
      Partner: true,
      Market: true,
      Customers: true,
      Competitors: true,
      SwotAnalysis: true,
      MarketPotential: true,
      ManagementTeam: true,
      Ownership: true
    },

    businessGuideStartHereShow: true
  }
}

const state = getDefaultState()

const getters = {
  isMenuCollapsed (state) {
    return !!state.menuCollapsed
  },

  getGettingStartedExpanded (state) {
    return state.home.gettingStartedExpanded
  },

  getHandWritings (state) {
    return state.handWritings
  },

  getAiBuddyButtonAnimationsShow (state) {
    return state.aiBuddyButtonAnimationShow
  },

  getBusinessPlanAdditionalInfoExpand: (state) => (section) => {
    return state.businessPlanAdditionalInfoExpand[section]
  },

  getBusinessGuideStartHereShow (state) {
    return state.businessGuideStartHereShow
  }
}

const mutations = {
  setMenuCollapsedToggle (state) {
    state.menuCollapsed = !state.menuCollapsed
  },

  setGettingStartedExpandedState (state, data) {
    state.home.gettingStartedExpanded = data
  },

  setHandWriting (state, { key, value }) {
    state.handWritings[key] = value
  },

  setAiBuddyButtonAnimationShow (state, { key, value }) {
    state.aiBuddyButtonAnimationShow[key] = value
  },

  setBusinessPlanAdditionalInfoExpanded (state, { key, value }) {
    state.businessPlanAdditionalInfoExpand[key] = value
  },

  setBusinessGuideStartHereShow (state, value) {
    state.businessGuideStartHereShow = value
  }
}

export default {
  state,
  getters,
  mutations,
  namespaced: true
}
